// extracted by mini-css-extract-plugin
export var heading = "ScreenReaderHeading-module__heading___2-AJG";